// src/components/LayoutWrapper.js

import React, { useState, useEffect } from "react";
import CustomScrollbar from "./CustomScrollbar";
import Header from "./Header";
import Footer from "./Footer";

function LayoutWrapper({ children, theme, toggleTheme, openContactForm }) {
  const [isFooterVisible, setIsFooterVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      const isAtBottom = windowHeight + currentScrollPos >= documentHeight - 10;
      setIsFooterVisible(isAtBottom);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    // Trigger an initial scroll event
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <CustomScrollbar />
      <Header
        theme={theme}
        toggleTheme={toggleTheme}
        isVisible={true}
        openContactForm={openContactForm} // Pass openContactForm to Header
      />
      <main>{children}</main>
      <Footer isVisible={isFooterVisible} openContactForm={openContactForm} />
    </>
  );
}

export default LayoutWrapper;
